

class FooterController {
  constructor() {
  	'ngInject';

  	this.appName = "Rangers";
  	this.date = new Date();
  }  
}

FooterController.$inject = []

export default FooterController;



// WEBPACK FOOTER //
// ./client/app/layout/footer.controller.js